import React from "react";
import { FaUsers, FaCalendarCheck } from "react-icons/fa6";
import banner11 from "../assets/banner9.jpg";
import { FaMailBulk } from "react-icons/fa";

export default function BulkSMS() {
  const features = [
    { icon: <FaMailBulk size={20} className="text-primary" />, text: "Mass communication and notifications via SMS gateways." },
    { icon: <FaUsers size={20} className="text-primary" />, text: "Coordinate participants for events and campaigns efficiently." },
    { icon: <FaCalendarCheck size={20} className="text-primary" />, text: "Automated scheduling, reminders, and alert management." },
  ];

  return (
    <section className="MainBodySection service-detail-page">
      <div className="container service-detail-shell">
        <div className="text-center">
          <div className="section-kicker mb-3">Service Detail</div>
          <h2 className="main-section-title">Bulk SMS & Event Management System</h2>
          <p className="section-copy">
            Integration of bulk messaging platforms with event management capabilities to enable mass communication, notifications, alerts, and participant coordination.
          </p>
        </div>

        <div className="service-detail-media">
          <img src={banner11} alt="Bulk SMS & Event Management" />
        </div>

        <div className="detail-card">
          <p className="detail-summary mb-4">
            Streamline communications for events, campaigns, or operations by combining SMS outreach with event coordination and participant management.
          </p>

          <ul className="detail-feature-list mb-4">
            {features.map(item => (
              <li key={item.text} className="detail-feature-item">{item.icon}<span>{item.text}</span></li>
            ))}
          </ul>

          <ol className="detail-step-list">
            <li>Set up SMS gateway integration for your organization.</li>
            <li>Import contacts and configure messaging groups.</li>
            <li>Schedule and send notifications, reminders, and alerts.</li>
            <li>Track delivery, responses, and event participation effectively.</li>
          </ol>
        </div>
      </div>
    </section>
  );
}